
export type AdItemType = {
    id?: string,
    name?: string,
    clientId?: string,
    organizationId?: string,
    organizationName?: string,
    published?: boolean,
    type?: AdItemTypeType,

    link?: string,
    linkText?: string,

    title01?: string,
    title02?: string,
    title03?: string,
    title04?: string,
    title05?: string,

    imageUrl?: string,
    plantIds?: string,

    startDateKey?: number,
    endDateKey?: number,
    adGroupName?: string,
    projectId?: string,
    archived?: boolean,
    adstate?: AdStateType,
    num_views?: number,
    num_press?: number,
    num_users_view?: number,
    num_users_press?: number,
    stats_updated_epoch?: number

}

export const AdItemTypeDefaultValue: AdItemType = {
    id: "",
    name: "",
    clientId: "",
    type: ""
}

// From 'OhGardenWeb.Lib.Models.BasicModels.AdModels.AdItemTypes'
export type AdItemTypeType = "" |
    // Plants
    "plantsearch" |
    "plantdetail_main" |
    "plantdetail_main_web" |

    // Forum-Feed
    "forum_feed" |

    // discovery
    "discovery_featured" |
    "discovery_featured_secondary" |
    "discovery_featured_plants" |

    "monthly_article" |
    // discovery
    "calendar_list" |

    // Erbjudande
    "offer";

export type AdStateType = "active" | "for_review" | "draft" | "archived";
export const AdStateTypesAsList = ["active", "for_review", "draft"];

export type AdClientType = {
    id: string,
    name: string,
    label?: "adclient"
}
export type AdOrganizationType = {
    id: string
    name: string
    label?: "organization"
}
export type AdProjectType = {
    id?: string,
    name?: string,
    clientId?: string,
    organizationId?: string,
    organizationName?: string,
    price?: number,
    adstate?: AdStateType

    hasinstagramstory?: boolean,
    hasinstagrampost?: boolean,
    hassponsoredpost?: boolean,
    hassponsoredblog?: boolean,
    haspushnotification?: boolean,

    instagramstory_num_press?: number,
    instagramstory_num_views?: number,
    instagrampost_num_press?: number,
    instagrampost_num_views?: number,
    sponsoredpost_num_press?: number,
    sponsoredpost_num_views?: number,
    sponsoredblog_num_press?: number,
    sponsoredblog_num_views?: number,
    pushnotification_num_press?: number,
    pushnotification_num_views?: number,

    startdatekey?: number,
    enddatekey?: number,
    deadlinedatekey?: number,
    packagename?: string,
    targetviews?: number

}
export const AdProjectTypeDefaultValue: AdProjectType = {
    id: "",
    name: "",
    clientId: "",
    organizationId: "",
    hasinstagramstory: false,
    hasinstagrampost: false,
    hassponsoredpost: false,
    hassponsoredblog: false,
    haspushnotification: false,

    instagramstory_num_press: 0,
    instagramstory_num_views: 0,
    instagrampost_num_press: 0,
    instagrampost_num_views: 0,
    sponsoredpost_num_press: 0,
    sponsoredpost_num_views: 0,
    sponsoredblog_num_press: 0,
    sponsoredblog_num_views: 0,
    pushnotification_num_press: 0,
    pushnotification_num_views: 0,

}

export type AdProjectBundleType = {
    adProjects: AdProjectType[],
    ads: AdItemType[],
    message: string,
    statusCode: number
    success: boolean
}

export type AdItemStatisticsType = {
    num_views: number,
    num_press: number,
    num_users: number,
    num_users_view: number,
    num_users_press: number
}